import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, setToken } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace("#", ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/admin");
      return;
    }
    api.post("/auth/session", { session_id: sessionId })
      .then((res) => {
        if (res.data?.session_token) setToken(res.data.session_token);
        window.history.replaceState(null, "", "/admin/dashboard");
        navigate("/admin/dashboard");
      })
      .catch(() => navigate("/admin"));
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#09090B] text-white flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin mx-auto mb-4 text-[#FF5A00]" />
        <div className="text-sm text-zinc-400">Validando sesión...</div>
      </div>
    </div>
  );
}
